<template>
  <!--START FOOTER-->
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 margin-t-20">
          <h4>Startandu</h4>
          <div class="text-muted margin-t-20">
            <ul class="list-unstyled footer-list">
              <li><a href="#">Home</a></li>
              <li><a href="#">Sobre</a></li>
              <li><a href="#">Carreiras</a></li>
              <li><a href="#">Contato</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 margin-t-20">
          <h4>Information</h4>
          <div class="text-muted margin-t-20">
            <ul class="list-unstyled footer-list">
              <li><a href="#">Termos e Condições</a></li>
              <li><a href="#">Sobre</a></li>
              <li><a href="#">Jobs</a></li>
              <li><a href="#">Marcadores</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 margin-t-20">
          <h4>Support</h4>
          <div class="text-muted margin-t-20">
            <ul class="list-unstyled footer-list">
              <li><a href="">FAQ</a></li>
              <li><a href="">Contato</a></li>
              <li><a href="">Fórum</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 margin-t-20">
          <h4>Subscribe</h4>
          <div class="text-muted margin-t-20">
            <p>Fique por dentro do que há de mais inovador:</p>
          </div>
          <form class="form subscribe">
            <input placeholder="Email" class="form-control" required />
            <a href="#" class="submit"><i class="pe-7s-paper-plane"></i></a>
          </form>
        </div>
      </div>
    </div>
  </footer>
  <!--END FOOTER-->
</template>

<script>
export default {
  name: "FooterSection",
  props: {}
};
</script>
